import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { ResponseApi } from '../models/response-api';
import { ImagenApi, PedidoListApi, SubirComprobantePayload, TransaccionApi } from '../models/api/pedido-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class PagoService {
    private http = inject(HttpClient);
    private pagoUrl = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/pago/';
    private imagenUrl = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/imagen/';

    // Sube el voucher (Yape/Plin) y retorna el uuid de la imagen guardada.
    uploadVoucher(file: File): Observable<string> {
        const form = new FormData();
        form.append('files', file, file.name);
        return this.http.post<ResponseApi<ImagenApi[]>>(this.imagenUrl + 'upload-comprobante', form).pipe(
            map((res) => {
                if (res.success !== Constante.REQUEST_STATUS_OK || !res.data?.length) {
                    const errors = res.errors as { message?: string }[] | null;
                    throw new Error(errors?.[0]?.message || res.message || 'No se pudo subir el comprobante.');
                }
                return res.data[0].uuid;
            })
        );
    }

    // Flujo completo: subir voucher y vincularlo al pedido.
    pagarConVoucher(pedidoUuid: string, file: File): Observable<TransaccionApi> {
        return this.uploadVoucher(file).pipe(
            switchMap((imagenUuid) => this.subirComprobante({ pedidoUuid, imagenUuid }))
        );
    }

    listPorVerificar(): Observable<PedidoListApi[]> {
        return this.http.get<ResponseApi<PedidoListApi[]>>(this.pagoUrl + 'list-pagos-por-verificar').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    aprobarPago(pedidoUuid: string): Observable<TransaccionApi> {
        return this.http.put<ResponseApi<TransaccionApi>>(this.pagoUrl + 'aprobar-pago/' + pedidoUuid, {}).pipe(
            map((res) => this.requireData(res))
        );
    }

    rechazarPago(pedidoUuid: string, motivoRechazo: string): Observable<TransaccionApi> {
        return this.http.put<ResponseApi<TransaccionApi>>(this.pagoUrl + 'rechazar-pago/' + pedidoUuid, { motivoRechazo }).pipe(
            map((res) => this.requireData(res))
        );
    }

    subirComprobante(body: SubirComprobantePayload): Observable<TransaccionApi> {        return this.http.post<ResponseApi<TransaccionApi>>(this.pagoUrl + 'subir-comprobante', body).pipe(
            map((res) => {
                if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
                    const errors = res.errors as { message?: string }[] | null;
                    throw new Error(errors?.[0]?.message || res.message || 'No se pudo registrar el comprobante.');
                }
                return res.data;
            })
        );
    }

    private requireData(res: ResponseApi<TransaccionApi>): TransaccionApi {
        if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
            const errors = res.errors as { message?: string }[] | null;
            throw new Error(errors?.[0]?.message || res.message || 'Ocurrió un error inesperado.');
        }
        return res.data;
    }
}
